import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ actions, onActionClick }) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {actions?.map((action) => (
          <Button
            key={action?.id}
            variant={action?.variant || 'outline'}
            iconName={action?.icon}
            iconPosition="left"
            onClick={() => onActionClick(action?.id)}
            fullWidth
            className="justify-start"
          >
            {action?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;